import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { NamedListedReportRecipientCompany } from 'helper/mailer';
import Icon from 'components/DesignSystem/Icon';
import Accordion from 'components/Accordion';
import { cssVar } from 'constants/theme';
import ReportUserCard from '../../ReportUserCard';
import './index.scss';

const ACTIVE_COLOR = cssVar('success-solid');
const INACTIVE_COLOR = cssVar('text-disabled');

export default function RecipientCompanyRow({ recipientCompany }: {
  recipientCompany: NamedListedReportRecipientCompany,
}) {
  return (
    <Accordion.Item eventKey={String(recipientCompany.id)}>
      <Accordion.Header variant="nested">
        <Row className="w-100 align-items-center">
          <Col md="9">{recipientCompany.name}</Col>
          <Col md="1">
            <Icon
              iconType="word"
              color={recipientCompany.wordGenerated ? ACTIVE_COLOR : INACTIVE_COLOR}
              size="large"
            />
          </Col>
          <Col md="1">
            <Icon
              iconType="pdf"
              color={recipientCompany.pdfGenerated ? ACTIVE_COLOR : INACTIVE_COLOR}
              size="large"
            />
          </Col>
          <Col md="1">
            <div>
              <Icon
                iconType="message"
                color={recipientCompany.emailGenerated ? ACTIVE_COLOR : INACTIVE_COLOR}
                size="large"
              />
              <span className="mail-read-badge">{recipientCompany.emails.length}</span>
            </div>
          </Col>
        </Row>
      </Accordion.Header>
      <Accordion.Body>
        <Row className="mx-3">
          {recipientCompany.emails.map((email) => (
            <Col key={email.id} md={6} xl={4}>
              <ReportUserCard email={email} />
            </Col>
          ))}
        </Row>
      </Accordion.Body>
    </Accordion.Item>
  );
}
